// 自定义列信息
export const customColumns = [
  {
    key: 'aggregation_info',
    children: [
      {
        key: 'budget_name',
        isSelected: true,
      },
      {
        key: 'is_new_customer',
        isSelected: true,
      },
      {
        key: 'sale_type',
        isSelected: true,
      }
    ],
  },
  {
    key: 'product_info',
    children: [
      {
        key: 'product_name',
        isSelected: true,
      },
      {
        key: 'product_series_name',
        isSelected: true,
      },
      {
        key: 'customer_cate',
        isSelected: true,
      },
    ],
  },

  {
    key: 'agent_adv',
    children: [
      {
        key: 'agent_id',
        isSelected: false,
      },
      {
        key: 'agent_name',
        isSelected: false,
      },
      {
        key: 'agent_company',
        isSelected: false,
      },
      {
        key: 'account_id',
        isSelected: false,
      },
      {
        key: 'account_name',
        isSelected: false,
      },
      {
        key: 'account_company',
        isSelected: false,
      },

      // {
      //   key: 'category',
      //   isSelected: false,
      // },

      {
        key: 'category_one',
        isSelected: false,
      },
      {
        key: 'category_two',
        isSelected: false,
      },
      {
        key: 'category_three',
        isSelected: false,
      },


      {
        key: 'app_marketing_type',
        isSelected: false,
      },
    ],
  },

  {
    key: 'owners_info',
    children: [
      // {
      //   key: 'owner_names',
      //   isSelected: true,
      //   disabled: true,
      // },
      {
        key: 'weight_cost',
        isSelected: true,
      },
      {
        key: 'weight_cash_cost',
        isSelected: true,
      },
      {
        key: 'weight_coupon_cost',
        isSelected: true,
      },
      {
        key: 'sale_weight',
        isSelected: true,
      },
    ],
  }
];

// 自定义列信息
export const customColumns2 = [
  {
    key: 'aggregation_info',
    children: [
      {
        key: 'budget_name',
        isSelected: true,
      },
      {
        key: 'is_new_customer',
        isSelected: true,
      },
      {
        key: 'sale_type',
        isSelected: true,
      }
    ],
  },
  {
    key: 'product_info',
    children: [
      {
        key: 'product_name',
        isSelected: true,
      },
      {
        key: 'product_series_name',
        isSelected: true,
      },
      {
        key: 'customer_cate',
        isSelected: true,
      },
    ],
  },
  {
    key: 'agent_adv',
    children: [
      {
        key: 'agent_id',
        isSelected: false,
      },
      {
        key: 'agent_name',
        isSelected: false,
      },
      {
        key: 'agent_company',
        isSelected: false,
      },
      {
        key: 'account_id',
        isSelected: false,
      },
      {
        key: 'account_name',
        isSelected: false,
      },
      {
        key: 'account_company',
        isSelected: false,
      },
      {
        key: 'category_one',
        isSelected: false,
      },
      {
        key: 'category_two',
        isSelected: false,
      },
      {
        key: 'category_three',
        isSelected: false,
      },
      {
        key: 'app_marketing_type',
        isSelected: false,
      },
    ],
  },
  
];

// 固定显示的表格列
export const fixedColumns = [
  {
    key: 'base_info2',
    children: [
      {
        key: 'date',
      },
      {
        key: 'owner_names',
      },
      // {
      //   key: 'budget_name',
      // },
      // {
      //   key: 'sale_type',
      // }
    ],
  },
];

// 折线图指标
export const fields = [
  // 'served_request',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_cash',
  'cost_coupon',
];

// 包含涨幅数据的字段
export const fieldWithDiff = [
  // 'served_request',
  'cost_cash',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_coupon',
  'acp',
  'ecpm',
  'list_acp',
  'detail_acp',
  'list_ecpm',
  'detail_ecpm',
  'cpa_given',
  'put_ideas_num',
  'put_plans_num',
  // 'new_ideas_num',
  'cvr',
  'deep_cvr',
  'cpa',
  'deep_cpa',
  'api_app_active_cost',
  'api_app_register_cost',
  'api_app_lahuo_cost',
  'cvr_keyaction_num',
  'api_app_keyaction_cost',
  'api_app_pay_cost',
  'api_app_retention_active_rate',
  'api_app_retention_register_rate',
  'api_app_retention_lahuo_rate',
];
